export const SNAP_II_SCORE = {
  masterTableName: "MC_SNAPII_SCORES",
  tableName: "MC_SNAPII_SCORES_DET",
  columnName: "SS_ID",
  columnValue: 0,
  title: "snap2-score.title",
  rows: [
    { title: "date", value: "PROCESS_TIME", headerName: "Tarih", type: "date" },
    {
      title: "MEAN_ARTERIAL_PRESSURE",
      value: "MEAN_ARTERIAL_PRESSURE_XNAME",
    },
    { title: "MINIMUM_TEMP", value: "MINIMUM_TEMP_XNAME" },
    { title: "PO2_FIO2", value: "PO2_FIO2_XNAME" },
    { title: "MINIMUM_PLASMA_PH", value: "MINIMUM_PLASMA_PH_XNAME" },
    { title: "MULTIPLE_SEIZURES", value: "MULTIPLE_SEIZURES_XNAME" },
    { title: "DIUREZ", value: "DIUREZ_XNAME" },
    { title: "APGAR_SCORE", value: "APGAR_SCORE_XNAME" },
    { title: "BIRTH_WEIGHT", value: "BIRTH_WEIGHT_XNAME" },
    { title: "HYPOTROPHY", value: "HYPOTROPHY_XNAME" },
    { title: "OBS_MORTALITY_RATE_OW", value: "OBS_MORTALITY_RATE_OW" },
    { title: "CALC_MORTALITY_RATE_OW", value: "CALC_MORTALITY_RATE_OW" },
    { title: "OBS_MORTALITY_RATE_BW", value: "OBS_MORTALITY_RATE_BW" },
    { title: "CALC_MORTALITY_RATE_BW", value: "CALC_MORTALITY_RATE_BW" },
    { title: "SNAPPEII_SCORE", value: "SNAPPEII_SCORE" },
  ],
  fields: [
    { field: "date", headerName: "datetime", flex: 1, type: "date" },
    {
      field: "MEAN_ARTERIAL_PRESSURE",
      headerName: "snap2-score.meanArterialPressure",
      flex: 1,
    },
    {
      field: "MINIMUM_TEMP",
      headerName: "snap2-score.minTemperature",
      flex: 1,
    },
    { field: "PO2_FIO2", headerName: "snap2-score.po2FiO2", flex: 1 },
    {
      field: "MINIMUM_PLASMA_PH",
      headerName: "snap2-score.minPlasmaph",
      flex: 1,
    },
    {
      field: "MULTIPLE_SEIZURES",
      headerName: "snap2-score.multipleSeizures",
      flex: 1,
    },
    { field: "DIUREZ", headerName: "snap2-score.diuresis", flex: 1 },
    {
      field: "SNAPII_SCORE",
      headerName: "snap2-score.snapIIScore",
      flex: 1,
      computed: true,
      calculate: (row: any) => {
        if (!row) return 0;
        const meanArterialPressure =
          Number(row.MEAN_ARTERIAL_PRESSURE_XVALUE) || 0;
        const minimumTemp = Number(row.MINIMUM_TEMP_XVALUE) || 0;
        const po2FiO2 = Number(row.PO2_FIO2_XVALUE) || 0;
        const minimumPlasmaPh = Number(row.MINIMUM_PLASMA_PH_XVALUE) || 0;
        const multipleSeizures = Number(row.MULTIPLE_SEIZURES_XVALUE) || 0;
        const diurez = Number(row.DIUREZ_XVALUE) || 0;

        const totalScore =
          meanArterialPressure +
          minimumTemp +
          po2FiO2 +
          minimumPlasmaPh +
          multipleSeizures +
          diurez;
        return totalScore;
      },
    },
    { field: "APGAR_SCORE", headerName: "snap2-score.apgarScore", flex: 1 },
    { field: "BIRTH_WEIGHT", headerName: "snap2-score.birthWeight", flex: 1 },
    { field: "HYPOTROPHY", headerName: "snap2-score.hypotrophy", flex: 1 },
    {
      field: "SNAPPEII_SCORE",
      headerName: "snap2-score.snapPeIIScore",
      flex: 1,
      computed: true,
      calculate: (row: any) => {
        if (!row) return 0;
        const meanArterialPressure =
          Number(row.MEAN_ARTERIAL_PRESSURE_XVALUE) || 0;
        const minimumTemp = Number(row.MINIMUM_TEMP_XVALUE) || 0;
        const po2FiO2 = Number(row.PO2_FIO2_XVALUE) || 0;
        const minimumPlasmaPh = Number(row.MINIMUM_PLASMA_PH_XVALUE) || 0;
        const multipleSeizures = Number(row.MULTIPLE_SEIZURES_XVALUE) || 0;
        const diurez = Number(row.DIUREZ_XVALUE) || 0;
        const apgarScore = Number(row.APGAR_SCORE_XVALUE) || 0;
        const birthWeight = Number(row.BIRTH_WEIGHT_XVALUE) || 0;
        const hypotrophy = Number(row.HYPOTROPHY_XVALUE) || 0;

        const totalScore =
          meanArterialPressure +
          minimumTemp +
          po2FiO2 +
          minimumPlasmaPh +
          multipleSeizures +
          diurez +
          apgarScore +
          birthWeight +
          hypotrophy;
        return totalScore;
      },
    },
    {
      field: "OBS_MORTALITY_RATE_OW",
      headerName: "snap2-score.observedMortalityRate",
      flex: 1,
    },
    {
      field: "CALC_MORTALITY_RATE_OW",
      headerName: "snap2-score.calculatedMortalityRate",
      flex: 1,
    },
    {
      field: "OBS_MORTALITY_RATE_BW",
      headerName: "snap2-score.observedMortalityRate",
      flex: 1,
    },
    {
      field: "CALC_MORTALITY_RATE_BW",
      headerName: "snap2-score.calculatedMortalityRate",
      flex: 1,
    },
  ],
  mcpConfig: {
    MEAN_ARTERIAL_PRESSURE: {
      mcpId: 355,
      field: "MEAN_ARTERIAL_PRESSURE",
      scoreField: "MEAN_ARTERIAL_PRESSURE_XVALUE",
    },
    MINIMUM_TEMP: {
      mcpId: 356,
      field: "MINIMUM_TEMP",
      scoreField: "MINIMUM_TEMP_XVALUE",
    },
    PO2_FIO2: {
      mcpId: 357,
      field: "PO2_FIO2",
      scoreField: "PO2_FIO2_XVALUE",
    },
    MINIMUM_PLASMA_PH: {
      mcpId: 358,
      field: "MINIMUM_PLASMA_PH",
      scoreField: "MINIMUM_PLASMA_PH_XVALUE",
    },
    MULTIPLE_SEIZURES: {
      mcpId: 359,
      field: "MULTIPLE_SEIZURES",
      scoreField: "MULTIPLE_SEIZURES_XVALUE",
    },
    DIUREZ: { mcpId: 360, field: "DIUREZ", scoreField: "DIUREZ_XVALUE" },
    APGAR_SCORE: {
      mcpId: 361,
      field: "APGAR_SCORE",
      scoreField: "APGAR_SCORE_XVALUE",
    },
    BIRTH_WEIGHT: {
      mcpId: 362,
      field: "BIRTH_WEIGHT",
      scoreField: "BIRTH_WEIGHT_XVALUE",
    },
    HYPOTROPHY: {
      mcpId: 363,
      field: "HYPOTROPHY",
      scoreField: "HYPOTROPHY_XVALUE",
    },
  } as Record<string, { mcpId: number; field: string; scoreField: string }>,
  formData: {
    SS_ID: "",
    CTIME: new Date(),
    PROCESS_TIME: new Date(),
    CUSER: "",
    MEAN_ARTERIAL_PRESSURE: "",
    MINIMUM_TEMP: "",
    PO2_FIO2: "",
    MINIMUM_PLASMA_PH: "",
    MULTIPLE_SEIZURES: "",
    DIUREZ: "",
    SNAPII_SCORE: "",
    APGAR_SCORE: "",
    BIRTH_WEIGHT: "",
    HYPOTROPHY: "",
    SNAPPEII_SCORE: "",
    OBS_MORTALITY_RATE_OW: "",
    CALC_MORTALITY_RATE_OW: "",
    OBS_MORTALITY_RATE_BW: "",
    CALC_MORTALITY_RATE_BW: "",
  },
  chartScoreField: "SNAPPEII_SCORE",
  chartTimeField: "PROCESS_TIME",
};
